import { SET_UNITS, SET_UNITS_ERROR, SET_UNITS_LOADING } from "../../actions/unitAction";

const initialState = {
  datas: null,
  loading: false,
  error: null
};

const unitReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UNITS:
      return { ...state, datas: action.data, error: null };
    case SET_UNITS_LOADING:
      return { ...state, loading: action.status };
    case SET_UNITS_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default unitReducer;
